import { Component, ViewChild } from "@angular/core";
import { ColumnBase } from "@progress/kendo-angular-grid";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { ITab, TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer, VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { EntityBase, GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { InvGoodsKind, RowAccessKind, RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { SoftWareLicenseKind } from "projects/sepidz-web-framework/src/lib/models/license-information.model";
import { GridFilter, LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { take } from "rxjs/operators";
import { RowAccessComponent } from "src/app/gnr/row-access/row-access.component";
import { GoodsFormulaDetail, GoodsFormulaHeader, GoodsSimilar } from "../../models/goods-formula-detail.model";
import { Goods } from "../../models/goods.model";
import { GoodsFormComponent } from "../goods-form/goods-form.component";
import { GoodsFormulaComponent } from "../goods-formula/goods-formula.component";
import { GoodsImportExportFormComponent } from "../goods-import-export/goods-import-export-form.component";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { GoodsImportExcelFormComponent } from "../goods-import-excel/goods-import-excel-form.component";
@Component({
  selector: "ngx-goods-list",
  templateUrl: "./goods-list.component.html",
  styleUrls: ["./goods-list.component.scss"],
})
export class GoodsListComponent extends BaseListComponent {
  @ViewChild("grid") grid: KGridComponent;

  actions: EntityListAction[];
  clipBoard: Goods;
  HasRowAccess: boolean;

  constructor(
    private lookupservice: LookupService,
    private splashFormService: SplashFormService,
    private missetup: MisSetupService,
    private tabsService: TabularService
  ) {
    super();
    this.inputEditorform = GoodsFormComponent;
    this.onActionClick = this.onActionClick.bind(this);
  }

  ngOnInit(): void {
    if (this.HasRowAccess === undefined) this.HasRowAccess = this.missetup.getboolean("GNR", "HasRowAccess");

    this.apiName = "Goods";
    this.areaName = "Inventory";
    this.label = this.translate("ClientApp.BackOffice.INV.Goods.GoodList");
    this.setactions();
  }

  setactions(): void {
    this.actions = [];
    const info = this.accountService.authService.currentInformation();
    if (
      info.InventoryKind === SoftWareLicenseKind.InventoryWeb ||
      info.InventoryKind === SoftWareLicenseKind.InventoryAdvancedWeb ||
      info.InventoryKind === SoftWareLicenseKind.InventoryToAdvancedWeb ||
      info.SaleInventory
    ) {
      const actions = [
        {
          name: "GetGoodsFormula",
          disabled: false,
          displayName: "اجزاء تشکیل دهنده کالا",
          iconName: "icon-pie_chart-o",
          apiName: "Goods/GetGoodsFormula",
          areaName: "Inventory",
          isModal: false,
          requireSelectedrows: true,
          Form_Component: GoodsFormulaComponent,
          permission: Permission.samePermission,
        },
        {
          name: "CopyGoodsFormula",
          disabled: false,
          displayName: "کپی اجزاء تشکیل دهنده کالا",
          iconName: "icon-copy2",
          apiName: "Goods/GetGoodsFormula",
          areaName: "Inventory",
          requireSelectedrows: true,
          Form_Component: GoodsFormulaComponent,
          permission: Permission.samePermission,
        },
        {
          name: "PasteGoodsFormula",
          disabled: false,
          displayName: "چسباندن(Paste)",
          iconName: "icon-paste2",
          apiName: "Goods/GetGoodsFormula",
          areaName: "Inventory",
          requireSelectedrows: true,
          Form_Component: GoodsFormulaComponent,
          permission: Permission.samePermission,
        },
      ];
      this.actions.push(...actions);
    }

    if (this.HasRowAccess === true) {
      this.actions.push({
        name: "RowAccess",
        disabled: false,
        displayName: "دسترسی در ردیف",
        iconName: "icon-users",
        apiName: "Goods/RowAccess",
        areaName: "Inventory",
        requireSelectedrows: true,
        Form_Component: RowAccessComponent,
        permission: Permission.samePermission,
      });
    }

    const actions = [
      {
        name: "ImportExport",
        disabled: false,
        displayName: "استخراج و دریافت",
        iconName: "icon-import_export-o",
        apiName: "Goods/ImportExport",
        areaName: "Inventory",
        Form_Component: GoodsImportExportFormComponent,
        permission: Permission.samePermission,
      },
      {
        name: "SendAllGoosToRakkaran",
        disabled: false,
        displayName: "ارسال کالا به راهکاران",
        iconName: "icon-send-F",
        apiName: "Goods/SendAllGoosToRakkaran",
        areaName: "Inventory",
        permission: Permission.samePermission,
      },
      {
        name: "ImportFromExcel",
        disabled: false,
        displayName: "ورودی اکسل",
        iconName: "icon-exel",
        apiName: "Goods/ImportExcel",
        areaName: "Inventory",
        Form_Component: GoodsImportExcelFormComponent,
        permission: Permission.samePermission,
      },
    ];
    this.actions.push(...actions);
  }

  saveGoodsFormula(data: Goods): void {
    this.httpCommonService
      .update("Goods", data)
      .pipe(take(1))
      .subscribe(
        (response) => console.log(""),
        (error) => console.log(error)
      );
  }

  onActionClick(action: EntityListAction, onRowSelected: Goods, onRowsSelected: Goods[], isAllSelected: boolean, gridFilter: GridFilter[]): void {
    switch (action.name) {
      case "GetGoodsFormula":
        if (onRowSelected && onRowSelected.GoodsKindCode !== InvGoodsKind.Product && onRowSelected.GoodsKindCode !== InvGoodsKind.HalfMade) {
          this.sts.showDialog("فقط کالا از نوع محصول /نیم ساخته قابل انتخاب است.", "");
          return;
        }
        this.onGetGoodsFormulaActionClick(action, onRowSelected);
        break;

      case "RowAccess":
        this.onRowAccessActionClick(onRowsSelected, onRowSelected, action);
        break;

      case "ImportFromExcel":
      case "ImportExport":
        this.onImportExportActionClick(action);
        break;

      case "CopyGoodsFormula":
        this.onCopyGoodsFormulaActionClick(onRowSelected);
        break;

      case "PasteGoodsFormula":
        if (onRowSelected && this.clipBoard) {
          if (onRowSelected.GoodsKindCode !== InvGoodsKind.HalfMade && onRowSelected.GoodsKindCode !== InvGoodsKind.Product) {
            this.sts.showDialog("کپی آنالیز فقط روی نیم ساخته و محصول امکان پذیر است.", "خطا");
            return;
          }
          this.onPasteGoodsFormulaActionClick(onRowSelected);
        }
        break;

      case "SendAllGoosToRakkaran":
        this.onSendAllGoodsToRahkaranActionClick(action);
        break;
    }
  }

  private onSendAllGoodsToRahkaranActionClick(action: EntityListAction): void {
    this.splashFormService.openDialog("", "در حال ارسال به راهکاران");
    this.httpCommonService
      .get(action.apiName)
      .pipe(take(1))
      .subscribe(
        (x) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog("ارسال به راهکاران با موفقیت صادر شد.", "");
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(`خطا در ارسال به راهکاران${Utilities.getHttpResponseMessage(error)}`, "خطا");
        }
      );
  }

  private onPasteGoodsFormulaActionClick(onRowSelected: Goods): void {
    this.httpCommonService
      .getItem<Goods>("Goods/GetGoodsFormula", this.clipBoard.Id)
      .pipe(take(1))
      .subscribe(
        (data) => {
          if (data) {
            let model = Object.assign({}, onRowSelected);
            model.State = RowState.Modify;
            data.GoodsFormulaHeaders.forEach((x) => {
              let gfh = Object.assign(<GoodsFormulaHeader>{}, x);
              gfh.GoodsId = onRowSelected.Id;
              gfh.Id = 0;
              gfh.Title = onRowSelected.Title;
              gfh.GoodsFormulaDetails = [];
              gfh.State = RowState.New;
              model.GoodsFormulaHeaders.push(gfh);
              x.GoodsFormulaDetails.forEach((gfd) => {
                let _gfd = Object.assign(<GoodsFormulaDetail>{}, gfd);
                _gfd.Id = 0;
                _gfd.State = RowState.New;
                _gfd.GoodsSimilars = [];
                _gfd.GoodsFormulaHeaderId = 0;
                gfh.GoodsFormulaDetails.push(_gfd);
                gfd.GoodsSimilars.forEach((s) => {
                  let gs = Object.assign(<GoodsSimilar>{}, s);
                  gs.Id = 0;
                  gs.State = RowState.New;
                  gs.GoodsFormulaDetailId = 0;
                  _gfd.GoodsSimilars.push(gs);
                });
              });
            });
            this.saveGoodsFormula(model);
          }
        },
        (error) => console.log(error)
      );
  }

  private onCopyGoodsFormulaActionClick(onRowSelected: Goods): void {
    if (onRowSelected) {
      if (onRowSelected.GoodsKindCode !== InvGoodsKind.HalfMade && onRowSelected.GoodsKindCode !== InvGoodsKind.Product) {
        this.sts.showDialog("کپی آنالیز فقط از نیم ساخته و محصول امکان پذیر است.", "خطا");
      } else this.clipBoard = onRowSelected;
    }
  }

  private onImportExportActionClick(action: EntityListAction): void {
    var gridInfo = this.getGridInfo(this.grid.grid.columns.toArray());
    this.dialogService
      .open(action.Form_Component, { gridInfo: gridInfo, label: action.displayName }, { autoFocus: true, closeOnClickOutside: false })
      .pipe(take(1))
      .subscribe((model: GridFilter[]) => {
        this.grid?.refreshData();
      });
  }

  private onRowAccessActionClick(onRowsSelected: Goods[], onRowSelected: Goods, action: EntityListAction): void {
    let ids: number[] = [];
    if (onRowsSelected != null && onRowsSelected.length > 0) onRowsSelected.forEach((x) => ids.push(x.Id));
    else ids.push(onRowSelected.Id);
    this.lookupservice
      .getLookupbyCode("Security", "RowAccess", RowAccessKind.Goods)
      .pipe(take(1))
      .subscribe(
        (x) => {
          this.dialogService
            .open(action.Form_Component, { SelectedRows: ids, RowKindId: x.Id }, { autoFocus: true, closeOnClickOutside: false })
            .pipe(take(1))
            .subscribe((model: GridFilter[]) => {});
        },
        (error) => {}
      );
  }

  private onGetGoodsFormulaActionClick(action: EntityListAction, onRowSelected: Goods): void {
    var dataTransfer: Datatransfer = <Datatransfer>{};
    dataTransfer.apiName = action.apiName;
    dataTransfer.label = this.label;
    dataTransfer.areaName = action.areaName;
    dataTransfer.currentrow = onRowSelected;
    const menu = <ITab>{
      title: `${this.label}-(ویرایش)`,
      isCloseable: true,
      icon: this.grid.icon,
      active: true,
      responsive: true,
      componentType: action.Form_Component,
      data: [
        { provide: EntityBase, useValue: onRowSelected },
        { provide: Datatransfer, useValue: dataTransfer },
        { provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: undefined } },
      ],
    };
    this.tabsService.open(menu);
  }

  getParamsForExportExcelWithPostMethod(): Promise<any> {
    return new Promise((resolve, reject) => {
      resolve(this.getGridInfo(this.grid.grid.columns.toArray()));
    });
  }

  getReportFilter(): Promise<any> {
    return new Promise((resolve, reject) => {
      resolve(this.getGridInfo(this.grid.grid.columns.toArray()));
    });
  }

  getGridInfo(columns: ColumnBase[]): GridColumnInfoDetail[] {
    return columns
      .filter((x) => !x.hidden)
      .map((x) => {
        const info = new GridColumnInfoDetail();
        info.name = x["field"];
        info.hidden = x.hidden;
        info.orderindex = x.orderIndex;
        info.title = x.title;
        return info;
      });
  }
}
